module.exports = __webpack_public_path__ + "media/fight-night-migos.6d033fbe.mp3";